import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './style.scss';
import WorkInformation from '../WorkInformation/WorkInformation';

const MeetUp = ({worklog, printable_text}) => {
  const {
    field_meet_id,
    standby_id,
    worklog_type,
  } = worklog;
  return (
    <div className={'meet-up'}>
      <div className={'header'}>
        <span>{worklog_type === 'fieldmeet_worklog' ? 'Field Meet' : 'Standby'}:</span>
        <Link
          to={`/ticketdetails/${field_meet_id || standby_id}`}
          className="work-ticket"
          onClick={(e) => e.stopPropagation()}
          disabled={true}
        >
          {field_meet_id ? field_meet_id : standby_id}
        </Link>
      </div>
      <WorkInformation printable_text={printable_text}/>
    </div>
  );
};

MeetUp.propTypes = {
  fieldMeet: PropTypes.object,
};

export default MeetUp;
